/*
 *
 * App reducer
 *
 */

import { createReducer } from '@reduxjs/toolkit';
import {
  defaultAction,
  defaultActionSuccess,
  defaultActionError,
  toggleTheme,
  setAppLoaded,
  setToken,
} from './actions';

export interface AppState {
  data: any;
  loading: boolean;
  error: string | null;
  isDarkMode: boolean;
  token: string | null;
  appLoaded: boolean;
}

const THEME_KEY = 'sajilo-theme';

function readStoredTheme(): boolean {
  try {
    return localStorage.getItem(THEME_KEY) === 'dark';
  } catch {
    return false;
  }
}

export const initialState: AppState = {
  data: null,
  loading: false,
  error: null,
  isDarkMode: readStoredTheme(),
  token: null,
  appLoaded: false,
};

const appReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(defaultAction, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(defaultActionSuccess, (state, action) => {
      state.loading = false;
      state.data = action.payload.data;
    })
    .addCase(defaultActionError, (state, action) => {
      state.loading = false;
      state.error = action.payload.error;
    })
    .addCase(toggleTheme, (state) => {
      state.isDarkMode = !state.isDarkMode;
      try {
        localStorage.setItem(THEME_KEY, state.isDarkMode ? 'dark' : 'light');
      } catch {
        /* storage unavailable — theme still applies for this session */
      }
    })
    .addCase(setAppLoaded, (state) => {
      state.appLoaded = true;
    })
    .addCase(setToken, (state, action) => {
      state.token = action.payload.token;
    });
});

export default appReducer;
